// ============================================================================
// openLitigationCase — bridge from row click → globally-mounted shell modal
// ============================================================================
// Mirrors the openCaseDetail() bridge for Pre-Litigation. The
// LitigationCaseDetailModal is mounted globally in main_layout; row clicks
// on LitigationCasesScreen dispatch this event, main_layout listens and
// toggles the shell open with the supplied caseId.

const LITIGATION_CASE_DETAIL_EVENT = 'recsuit:open-litigation-case-modal';
const SESSION_KEY = 'lit:caseDetailId';

export function openLitigationCase(caseId: string | number): void {
  try {
    sessionStorage.setItem(SESSION_KEY, String(caseId));
  } catch {
    /* sessionStorage unavailable — main_layout reads from event detail. */
  }
  window.dispatchEvent(
    new CustomEvent(LITIGATION_CASE_DETAIL_EVENT, {
      detail: { caseId: String(caseId) },
    }),
  );
}
